module.exports = __webpack_public_path__ + "img/icon_unselected_baihu.fd6fbd97.png";